import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { saveEventItem } from '../utils/firebaseFunctions'; // Assuming this function is generic
import Loader from './Loader';
import Sidebar from './Sidebar';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import { firestore } from '../firebase.config';
import {
    collection,
    getDocs,
    deleteDoc,
    doc,
    setDoc,
} from 'firebase/firestore';
import { Pencil, Trash2 } from 'lucide-react';
import moment from 'moment';

const LordKrishna = () => {
    const [Heading, setHeading] = useState('');
    const [Quote1, setQuote1] = useState(''); // New state for first quote
    const [Content, setContent] = useState(''); // Renamed from Description
    const [isLoading, setIsLoading] = useState(false);
    const [field, setField] = useState(false);
    const [alertStatus, setAlertStatus] = useState('danger');
    const [msg, setMsg] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [krishnaItems, setKrishnaItems] = useState([]);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editKrishnaData, setEditKrishnaData] = useState(null);

    const [editUploadedImageUrls, setEditUploadedImageUrls] = useState([]);
    const [editUploadProgress, setEditUploadProgress] = useState(0);

    const toggleSidebar = (state) => {
        setIsSidebarOpen(state);
    };

    const cloudName = "dabhatz7m";
    const uploadPreset = "ImageUpload";

    const [uploadedImageUrls, setUploadedImageUrls] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);

    const handleImageUpload = (e, isEdit = false) => {
        e.preventDefault();
        const file = e.target.files[0];

        if (!file) return alert("Please select an image!");

        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", uploadPreset);
        formData.append('folder', 'LordKrishnaImages');

        const xhr = new XMLHttpRequest();
        xhr.open("POST", `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, true);

        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percentComplete = (event.loaded / event.total) * 100;
                if (isEdit) {
                    setEditUploadProgress(percentComplete);
                } else {
                    setUploadProgress(percentComplete);
                }
            }
        };

        xhr.onload = () => {
            if (xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                if (!data.secure_url) {
                    console.error("Secure URL is missing from Cloudinary response");
                    return;
                }
                const imageUrl = data.secure_url;

                if (isEdit) {
                    setEditUploadedImageUrls((prevUrls) => [...prevUrls, imageUrl]);
                    setEditUploadProgress(0);
                } else {
                    setUploadedImageUrls((prevUrls) => [...prevUrls, imageUrl]);
                    setUploadProgress(0);
                }
            } else {
                console.error("Failed to upload image to Cloudinary");
                if (isEdit) {
                    setEditUploadProgress(0);
                } else {
                    setUploadProgress(0);
                }
            }
        };

        xhr.onerror = () => {
            console.error("Error uploading image:", xhr.statusText);
            if (isEdit) {
                setEditUploadProgress(0);
            } else {
                setUploadProgress(0);
            }
        };

        xhr.send(formData);
    };

    const handleDeleteImage = (index, isEdit = false) => {
        if (isEdit) {
            const updatedImages = [...editUploadedImageUrls];
            updatedImages.splice(index, 1);
            setEditUploadedImageUrls(updatedImages);
        } else {
            const updatedImages = [...uploadedImageUrls];
            updatedImages.splice(index, 1);
            setUploadedImageUrls(updatedImages);
        }
    };

    const saveDetails = async () => {
        setIsLoading(true);
        if (!Heading || !Quote1 || !Content || uploadedImageUrls.length === 0) {
            setField(true);
            setMsg("Required fields and image(s) can't be empty");
            setAlertStatus("danger");
            toast.error("Required fields and image(s) can't be empty");
            setTimeout(() => {
                setField(false);
                setIsLoading(false);
            }, 4000);
            return;
        }

        try {
            const id = `${Date.now()}`;

            const data = {
                id: id,
                Heading,
                Quote1, // Include Quote1
                Content, // Include Content
                imageUrls: [...uploadedImageUrls],
            };
            await setDoc(doc(firestore, "LordKrishna", id), data, { merge: true });

            setIsLoading(false);
            setField(true);
            setMsg("Details saved successfully");
            toast.success("Details saved successfully");
            clearData();

            setTimeout(() => {
                setField(false);
            }, 4000);
            fetchKrishnaItems();
        } catch (error) {
            console.error("Error saving details:", error);
            toast.error("Failed to save details");
            setIsLoading(false);
        }
    };

    const clearData = () => {
        setHeading('');
        setQuote1(''); // Clear Quote1
        setContent(''); // Clear Content
        setUploadedImageUrls([]);
    };

    const fetchKrishnaItems = async () => {
        try {
            const querySnapshot = await getDocs(collection(firestore, 'LordKrishna'));
            const items = [];
            querySnapshot.forEach((doc) => {
                items.push({ ...doc.data(), docId: doc.id });
            });
            setKrishnaItems(items);
        } catch (error) {
            console.error("Error fetching LordKrishna items:", error);
        }
    };
const handleDeleteKrishnaItem = async (docId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this Lord Krishna item? This action cannot be undone.");
        if (!confirmDelete) {
            return; // If the user cancels, stop the function
        }

        try {
            await deleteDoc(doc(firestore, 'LordKrishna', docId));
            toast.success("Deleted successfully");
            fetchKrishnaItems();
        } catch (error) {
            console.error("Error deleting LordKrishna item:", error);
            toast.error("Failed to delete");
        }
    };

    const openEditModal = (krishnaItem) => {
        setEditKrishnaData({ ...krishnaItem });
        setEditUploadedImageUrls([...krishnaItem.imageUrls]);
        setEditModalOpen(true);
    };

    const handleUpdateKrishnaItem = async () => {
        if (!editKrishnaData.Heading || !editKrishnaData.Quote1 || !editKrishnaData.Content || editUploadedImageUrls.length === 0) {
            toast.error("Please fill in all required fields and upload at least one image.");
            return;
        }

        try {
            const ref = doc(firestore, 'LordKrishna', editKrishnaData.docId);
            await setDoc(ref, {
                id: editKrishnaData.id,
                Heading: editKrishnaData.Heading,
                Quote1: editKrishnaData.Quote1, // Update Quote1
                Content: editKrishnaData.Content, // Update Content
                imageUrls: editUploadedImageUrls,
            }, { merge: true });

            toast.success("LordKrishna item updated successfully");
            setEditModalOpen(false);
            fetchKrishnaItems();
        } catch (err) {
            console.error(err);
            toast.error("Failed to update LordKrishna item");
        }
    };

    useEffect(() => {
        fetchKrishnaItems();
    }, []);

    return (
        <div className='lg:flex h-screen bg-white'>
            <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <div className={`flex-1 p-1 lg:p-12 overflow-y-auto transition-all duration-300 lg:mt-2 mt-16 ${isSidebarOpen ? 'ml-56 p-0' : 'lg:ml-20 sm:ml-2 '}`}>
                <div className={`w-full max-w-4xl mx-auto bg-white shadow-xl rounded-2xl lg:p-8 ${isSidebarOpen ? ' p-1' : 'lg:p-8 p-8'}`}>
                    <h1 className={`lg:text-2xl font-bold text-[#fcaf17] mb-6 ${isSidebarOpen ? 'text-[13px]' : ''}`}>Add Lord Krishna Items</h1>

                    {field && (
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className={`p-3 rounded-lg text-center text-lg font-medium ${alertStatus === "danger" ? "bg-red-100 text-red-600" : "bg-green-100 text-green-600"}`}
                        >
                            {msg}
                        </motion.p>
                    )}

                    <div className='lg:space-y-3 space-y-1'>
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`} htmlFor='Heading'>Heading</label>
                            <input
                                id='Heading'
                                type='text'
                                value={Heading}
                                autoComplete='off'
                                placeholder='Enter Heading'
                                onChange={(e) => setHeading(e.target.value)}
                                className={`w-full px-4 py-2 border border-gray-300 lg:text-md text-sm rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:outline-none ${isSidebarOpen ? 'text-xs' : ''}`}
                            />
                        </div>

                        {/* First Quote Input */}
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`} htmlFor='Quote1'> Quote</label>
                            <input
                                id='Quote1'
                                type='text'
                                value={Quote1}
                                autoComplete='off'
                                placeholder='Enter quote'
                                onChange={(e) => setQuote1(e.target.value)}
                                className={`w-full px-4 py-2 border border-gray-300 lg:text-md text-sm rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:outline-none ${isSidebarOpen ? 'text-xs' : ''}`}
                            />
                        </div>

                        {/* Content Textarea */}
                        <div>
                            <label
                                className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}
                                htmlFor="Content"
                            >
                                Content
                            </label>
                            <textarea
                                id="Content"
                                value={Content}
                                autoComplete="off"
                                placeholder="Enter content"
                                onChange={(e) => setContent(e.target.value)}
                                className={`w-full px-4 py-2 border border-gray-300 lg:text-md text-sm rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none ${isSidebarOpen ? 'text-xs' : ''}`}
                                rows="5" // Added rows for better textarea appearance
                            />
                        </div>

                        <div className="mb-4">
                            <label
                                className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}
                                htmlFor="imageInput"
                            >
                                Image Upload
                            </label>
                            <label
                                htmlFor="imageInput"
                                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                            >
                                <svg
                                    className="mr-2 h-5 w-5 text-[#fcaf17]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <span>Upload Images</span>
                            </label>
                            <input
                                type="file"
                                id="imageInput"
                                accept="image/*"
                                onChange={(e) => handleImageUpload(e, false)}
                                multiple
                                className="hidden"
                            />
                        </div>

                        {uploadProgress > 0 && (
                            <div className="mt-2">
                                <div className="bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                                    <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${uploadProgress}%` }}></div>
                                </div>
                                <p className="text-sm text-gray-600 text-center">{Math.round(uploadProgress)}%</p>
                            </div>
                        )}
                        <div id="imagesContainer" className="flex flex-wrap gap-4 mt-2">
                            {uploadedImageUrls.map((url, index) => (
                                <div
                                    key={index}
                                    className="relative w-[200px] h-[130px] border rounded-md overflow-hidden"
                                >
                                    <img
                                        src={url}
                                        alt={`Uploaded ${index}`}
                                        className="w-full h-full object-cover"
                                    />
                                    <button
                                        onClick={() => handleDeleteImage(index, false)}
                                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                                        title="Remove image"
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-start">
                            <button
                                className="bg-blue-600 text-white lg:text-sm text-xs py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300"
                                onClick={saveDetails}
                            >
                                {isLoading ? <Loader /> : 'Save '}
                            </button>
                        </div>
                    </div>
                </div>

                {krishnaItems.length > 0 ? (
                    <div className="mt-12 p-8 transform transition-all duration-300 hover:shadow-yellow-300/40">
                        <h2 className="text-3xl font-extrabold mb-8 text-[#fcaf17] tracking-wide flex items-center gap-3 animate-fade-in-down">
                            <span>✨</span> Lord Krishna Collection
                        </h2>

                        <div className="overflow-hidden border border-yellow-200 transform transition-all duration-300 hover:shadow-yellow-200/20">
                            <table className="min-w-full text-sm text-left text-gray-700">
                                <thead className="bg-gradient-to-r from-yellow-100 to-yellow-200/70 backdrop-blur-sm border-b border-yellow-300 text-[14px] uppercase font-bold tracking-wider text-orange-800 animate-slide-in-top">
                                    <tr>
                                        <th className="px-6 py-4">Sl. No.</th>
                                        <th className="px-6 py-4">Heading</th>
                                        <th className="px-6 py-4">Quote 1</th> {/* New header */}
                                        <th className="px-6 py-4">Content</th> {/* Changed from Description */}
                                        <th className="px-6 py-4">Image</th>
                                        <th className="px-6 py-4 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {krishnaItems.map((item, index) => (
                                        <tr
                                            key={item.docId}
                                            className="group bg-white/70 transition-all duration-300 hover:bg-orange-50/70 border-b border-orange-100 last:border-b-0 animate-fade-in"
                                        >
                                            <td className="px-6 py-4 font-semibold text-gray-800 text-base">
                                                {index + 1}
                                            </td>
                                            <td className="px-6 py-4 text-gray-900 font-medium">{item.Heading}</td>
                                            <td className="px-6 py-4 text-gray-600 text-sm leading-relaxed ">
                                                {item.Quote1} {/* Display Quote1 */}
                                            </td>
                                          
                                            <td className="px-6 py-4 text-gray-600 text-sm leading-relaxed ">
                                                {item.Content} {/* Display Content */}
                                            </td>
                                            <td className="px-6 py-4">
                                                <img
                                                    src={item.imageUrls[0]}
                                                    alt={`Lord Krishna Item ${index + 1}`}
                                                    className="w-28 h-20 object-cover rounded-xl border-2 border-gray-200 shadow-md group-hover:scale-105 group-hover:border-orange-400 transition-all duration-300 ease-in-out cursor-pointer"
                                                />
                                            </td>
                                            <td className="px-6 py-4 text-center flex justify-center gap-2">
                                                <button
                                                    onClick={() => openEditModal(item)}
                                                    className="inline-flex items-center gap-2 text-blue-600 hover:text-white bg-blue-100 hover:bg-blue-500 px-4 py-2 rounded-full text-sm font-semibold shadow-md transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2"
                                                    title="Edit Item"
                                                >
                                                    <Pencil size={16} />
                                                    Edit
                                                </button>

                                                <button
                                                    onClick={() => handleDeleteKrishnaItem(item.docId)}
                                                    className="inline-flex items-center gap-2 text-red-600 hover:text-white bg-red-100 hover:bg-red-500 px-4 py-2 rounded-full text-sm font-semibold shadow-md transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-300 focus:ring-offset-2"
                                                    title="Remove Item"
                                                >
                                                    <Trash2 className="w-4 h-4" />
                                                    Remove
                                                </button>
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className="mt-12 p-8 text-center text-gray-500 text-lg italic bg-white border border-orange-100 rounded-xl shadow-sm">
                        No beautiful Lord Krishna items to display yet. Let's create one!
                    </div>
                )}
                {/* --- Edit Modal --- */}
                {editModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center">
                        <div className="bg-white rounded-lg p-6 w-full max-w-2xl shadow-lg">
                            <h2 className="text-xl font-bold text-[#ea764d] mb-4">Edit Lord Krishna Item</h2>

                            <label className="block mb-2 text-sm font-medium text-gray-700">Heading</label>
                            <input
                                type="text"
                                value={editKrishnaData?.Heading || ''}
                                onChange={(e) => setEditKrishnaData({ ...editKrishnaData, Heading: e.target.value })}
                                className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
                            />

                            {/* Edit Quote 1 Input */}
                            <label className="block mb-2 text-sm font-medium text-gray-700"> Quote</label>
                            <input
                                type="text"
                                value={editKrishnaData?.Quote1 || ''}
                                onChange={(e) => setEditKrishnaData({ ...editKrishnaData, Quote1: e.target.value })}
                                className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
                            />

                            
                            {/* Edit Content Textarea */}
                            <label className="block mb-2 text-sm font-medium text-gray-700">Content</label>
                            <textarea
                                value={editKrishnaData?.Content || ''}
                                onChange={(e) => setEditKrishnaData({ ...editKrishnaData, Content: e.target.value })}
                                className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
                                rows="5" // Added rows for better textarea appearance
                            />

                            {/* --- Image Upload Section for Edit Modal --- */}
                            <div className="mb-4">
                                <label
                                    htmlFor="editImageInput"
                                    className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                                >
                                    <svg
                                        className="mr-2 h-5 w-5 text-[#ea764d]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    <span>Upload New Image(s)</span>
                                </label>
                                <input
                                    type="file"
                                    id="editImageInput"
                                    accept="image/*"
                                    onChange={(e) => handleImageUpload(e, true)}
                                    multiple
                                    className="hidden"
                                />
                            </div>

                            {editUploadProgress > 0 && (
                                <div className="mt-2">
                                    <div className="bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                                        <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${editUploadProgress}%` }}></div>
                                    </div>
                                    <p className="text-sm text-gray-600 text-center">{Math.round(editUploadProgress)}%</p>
                                </div>
                            )}

                            <div className="flex flex-wrap gap-3 mb-4">
                                {editUploadedImageUrls?.map((url, idx) => (
                                    <div key={idx} className="relative w-[100px] h-[80px] border rounded overflow-hidden">
                                        <img src={url} alt={`edit-img-${idx}`} className="w-full h-full object-cover" />
                                        <button
                                            onClick={() => handleDeleteImage(idx, true)}
                                            className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                                            title="Remove image"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                ))}
                            </div>
                            {/* --- End Image Upload Section for Edit Modal --- */}

                            <div className="flex justify-end gap-4">
                                <button
                                    onClick={() => setEditModalOpen(false)}
                                    className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleUpdateKrishnaItem}
                                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <style jsx>{`
                    @keyframes fade-in-down {
                        from {
                            opacity: 0;
                            transform: translateY(-20px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes slide-in-top {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes fade-in {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }

                    .animate-fade-in-down {
                        animation: fade-in-down 0.8s ease-out forwards;
                    }
                `}</style>
            </div>
        </div>
    );
};

export default LordKrishna;